module.exports = __webpack_public_path__ + "img/南网.1088fa7d.png";